import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { DEFAULT_SIGIL_LINKS } from "types/configs";

export const firebaseConfig = {
  local: {
    initConfig: {
      apiKey: "AIzaSyBxoAOM_8nW5EYiKfX_8R8BG-Riw1mvaEU",
      authDomain: "sigil-dev.firebaseapp.com",
      databaseURL: "https://sigil-dev-default-rtdb.firebaseio.com",
      projectId: "sigil-dev",
      storageBucket: "sigil-dev.appspot.com",
      messagingSenderId: "90111691183",
      appId: "1:90111691183:web:0bda1bc21ed2c7c5a1475a",
      measurementId: "G-V6Q9PXPEXN",
    },
    messaging: {
      publicVapidKey:
        "AAAAFPsTSa8:APA91bHZw7kWqlLipABEumsTEm61lV4XsqPm7A0ELJDJnRR5O0Nzfncf2KFuAGiNnxb73DQws8hlzjhr2zPmmAdnIXTgcwTYVN3zUxQcp6vt5eFxZ_xYhCTrsk6T0fzhUe-o5jl516j3",
    },
  },
  development: {
    initConfig: {
      apiKey: "AIzaSyBxoAOM_8nW5EYiKfX_8R8BG-Riw1mvaEU",
      authDomain: "sigil-dev.firebaseapp.com",
      databaseURL: "https://sigil-dev-default-rtdb.firebaseio.com",
      projectId: "sigil-dev",
      storageBucket: "sigil-dev.appspot.com",
      messagingSenderId: "90111691183",
      appId: "1:90111691183:web:0bda1bc21ed2c7c5a1475a",
      measurementId: "G-V6Q9PXPEXN",
    },
    messaging: {
      publicVapidKey:
        "AAAAFPsTSa8:APA91bHZw7kWqlLipABEumsTEm61lV4XsqPm7A0ELJDJnRR5O0Nzfncf2KFuAGiNnxb73DQws8hlzjhr2zPmmAdnIXTgcwTYVN3zUxQcp6vt5eFxZ_xYhCTrsk6T0fzhUe-o5jl516j3",
    },
  },
  demo: {
    initConfig: {
      apiKey: "AIzaSyCk6MsAFTqxWDM5jTH7ZdJtlSECrMDpE78",
      authDomain: "sigil-demo.firebaseapp.com",
      databaseURL: "https://sigil-demo-default-rtdb.firebaseio.com",
      projectId: "sigil-demo",
      storageBucket: "sigil-demo.appspot.com",
      messagingSenderId: "625471023223",
      appId: "1:625471023223:web:2e13e6596241949b75fe72",
      measurementId: "G-RCSJQM20M4",
    },
  },
  production: {
    initConfig: {
      apiKey: "AIzaSyC4PkW9sSaEWjudVhG2aHo0c6cYyAHFa-o",
      authDomain: "sigil-pricing.firebaseapp.com",
      databaseURL: "https://sigil-pricing-default-rtdb.firebaseio.com",
      projectId: "sigil-pricing",
      storageBucket: "sigil-pricing.appspot.com",
      messagingSenderId: "200286066754",
      appId: "1:200286066754:web:707ee3358b95febf6335db",
      measurementId: "G-RCSJQM20M4",
    },
    messaging: {
      publicVapidKey:
        "AAAALqH62EI:APA91bGuzSWKlPSe2WqZzby9dne9GPOcx0ydtjk2tBKCVwvyi76yEM6ooON6gFspSswNtFuLtJcYLk-Pnekkfmy_-Kx56fH4u4HvOpY_BmvOK8NJjRomQtf4uDxwPs_i152_Ebmw5cQ4",
    },
  },
  firebaseuiProps: {
    signInOptions: [
      {
        disableSignUp: {
          status: true,
          adminEmail: DEFAULT_SIGIL_LINKS.supportEmail,
        },
        provider: "password",
      },
    ],
  },
};

type FirebaseEnv = "local" | "development" | "demo" | "production";
const env = (process.env.REACT_APP_ENV as FirebaseEnv) || "development";
const app = getApps().length
  ? getApp()
  : initializeApp(firebaseConfig[env].initConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const storage = getStorage(app);

try {
  getAnalytics(app);
} catch {}

if (env === "local") {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", 8080);
  connectFunctionsEmulator(functions, "localhost", 5001);
  connectStorageEmulator(storage, "localhost", 9199);
}

export { app, auth, db, functions, storage };
